import React, { useEffect, useRef } from "react";
import Logo from "../../../img/NavBar/Dgreat Allot Pensions Logo.png";
import { ReactComponent as SignIn } from "../../../img/NavBar/sign_in.svg";
import { ReactComponent as Ham } from "../../../img/NavBar/Ham.svg";
import { ReactComponent as User } from "../../../img/NavBar/User.svg";
import { NavLink } from "react-router-dom";
import { Container } from "../../../utils/CustomComponents";
import { useUser } from "../../../utils/Contexts/Context";
import gsap from "gsap";
import OnOutsiceClick from "react-outclick";
function NavBar() {
    const nav_bar = useRef();
    const logo = useRef();
    const nav = useRef();
    const ham = useRef();
    const nav_wrapper = useRef();
    useEffect(() => {
        const tl = gsap.timeline();
        tl.from(logo.current, { opacity: 0, scale: 0.6 }).from(nav.current.children, {
            opacity: 0,
            y: -10,
            stagger: { each: 0.125 },
            duration: 0.5,
        });
        // This controlls the navbar state, (wether scrolled or not)
        window.addEventListener("scroll", () => {
            window.scrollY > 60
                ? nav_bar.current && nav_bar.current.classList.add("scrolled")
                : nav_bar.current && nav_bar.current.classList.remove("scrolled");
        });
    }, []);
    useEffect(() => {
        ham.current.onclick = () => {
            nav_wrapper.current.classList.toggle("open");
            ham.current.classList.toggle("open");
        };
        nav.current.onclick = () => {
            nav_wrapper.current.classList.remove("open");
            ham.current.classList.remove("open");
        };
    }, []);

    const { user } = useUser();
    return (
        <div id="nav_bar" ref={nav_bar}>
            <Container>
                <OnOutsiceClick
                    onOutsideClick={() => {
                        nav_wrapper.current && nav_wrapper.current.classList.remove("open");
                        ham.current && ham.current.classList.remove("open");
                    }}
                >
                    <div className="nav_bar_wrapper">
                        <div className="logo" ref={logo}>
                            <NavLink to="/">
                                <img src={Logo} alt="" />
                            </NavLink>
                        </div>
                        <NavItems nav_wrapper={nav_wrapper} navRef={nav}>
                            <NavItem text="home" url="" />
                            <NavItem text="about us" url="about" />
                            <NavItem text="contact" url="contact" />
                            <span className="bar"></span>
                            {user ? (
                                <NavItem sufIcon={<User />} text={user.name} url="dashboard" />
                            ) : (
                                <NavItem text="sign in" url="auth" sufIcon={<SignIn />} />
                            )}
                            <NavItem text="wallet" url="wallet" className="wallet" />
                        </NavItems>
                        {/* Hamburger that shows only on mobile */}
                        <div className="hamburger">
                            <Ham ref={ham} />
                        </div>
                    </div>
                </OnOutsiceClick>
            </Container>
        </div>
    );
}

export default NavBar;

function NavItems({ children, navRef, className, nav_wrapper }) {
    return (
        <nav className={className} ref={nav_wrapper}>
            <ul ref={navRef}>{children}</ul>
        </nav>
    );
}

function NavItem({ text = "", url = "", sufIcon, className }) {
    return (
        <NavLink to={`/${url}`} activeClassName="active" className={className} exact={url === ""}>
            {sufIcon}
            {text}
        </NavLink>
    );
}
